import React from "react";
import { useAppContext } from "../../../context/AppContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExpand, faCompress } from "@fortawesome/pro-solid-svg-icons";

const DoorView = ({ onToggleFullscreen, isFullscreen = false }) => {
    const {
        state: { view },
        setView,
    } = useAppContext();

    return (
        <div className="flex absolute top-2 right-2 sm:top-4 sm:right-4 z-20">
            <button
                className={`transition-colors p-1 sm:p-0 ${view === "external" ? "bg-[#cc2107]/90" : "bg-white/70"}`}
                onClick={() => {
                    setView("external");
                }}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="40"
                    height="37"
                    viewBox="0 0 74 69"
                    className="w-[32px] sm:w-[40px] h-auto mx-auto xl:w-[76px]"
                >
                    <g
                        id="Rectangle_725"
                        data-name="Rectangle 725"
                        fill={`${view === "external" ? "#cc2107" : "#ffffffcc"}`}
                        stroke={`${view === "external" ? "#cc2107" : "#ffffffcc"}`}
                        strokeWidth="1"
                    >
                        <rect width="74" height="69" stroke="none" />
                        <rect
                            x="0.5"
                            y="0.5"
                            width="73"
                            height="68"
                            fill="none"
                        />
                    </g>
                    <g
                        id="Group_1908"
                        data-name="Group 1908"
                        transform="translate(-1202 -169)"
                    >
                        <g
                            id="Rectangle_726"
                            data-name="Rectangle 726"
                            transform="translate(1224 182)"
                            fill={`${view === "external" ? "#cc2107" : "#fff"}`}
                            stroke={`${
                                view === "external" ? "#fff" : "#cc2107"
                            }`}
                            strokeWidth="1"
                        >
                            <rect width="31" height="47" stroke="none" />
                            <rect
                                x="0.5"
                                y="0.5"
                                width="30"
                                height="46"
                                fill="none"
                            />
                        </g>
                        <line
                            id="Line_12"
                            data-name="Line 12"
                            y2="37"
                            transform="translate(1249.5 186.5)"
                            fill="none"
                            stroke={`${
                                view === "external" ? "#fff" : "#cc2107"
                            }`}
                            strokeWidth="1"
                        />
                        <line
                            id="Line_13"
                            data-name="Line 13"
                            x2="41"
                            transform="translate(1218.5 229.5)"
                            fill="none"
                            stroke={`${
                                view === "external" ? "#fff" : "#cc2107"
                            }`}
                            strokeWidth="1"
                        />
                    </g>
                </svg>

                <span className={`text-[10px] sm:text-[12px] ${view === 'external' ? 'text-white px-1 sm:px-2' : 'text-gray-700 px-1 sm:px-2'}`}>External</span>
            </button>
            <button className={`transition-colors p-1 sm:p-0 ${view === "internal" ? "bg-[#cc2107]/90" : "bg-white/70"}`} onClick={() => setView("internal")}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="40"
                    height="37"
                    viewBox="0 0 74 69"
                    className="w-[32px] sm:w-[40px] h-auto mx-auto xl:w-[76px]"
                >
                    <g
                        id="Rectangle_725"
                        data-name="Rectangle 725"
                        fill={`${view === "internal" ? "#cc2107" : "#fff"}`}
                        stroke={`${view === "internal" ? "#cc2107" : "#fff"}`}
                        strokeWidth="1"
                    >
                        <rect width="74" height="69" stroke="none"/>
                        <rect
                            x="0.5"
                            y="0.5"
                            width="73"
                            height="68"
                            fill="none"
                        />
                    </g>
                    <path
                        id="Path_532"
                        data-name="Path 532"
                        d="M0,51"
                        transform="translate(1.5 6.5)"
                        fill="none"
                        stroke="#707070"
                        strokeWidth="1"
                        opacity="0.219"
                    />
                    <g
                        id="Rectangle_727"
                        data-name="Rectangle 727"
                        transform="translate(22 11)"
                        fill={`${view === "internal" ? "#cc2107" : "#fff"}`}
                        stroke={`${view === "internal" ? "#fff" : "#cc2107"}`}
                        strokeWidth="1"
                    >
                        <rect width="31" height="47" stroke="none"/>
                        <rect
                            x="0.5"
                            y="0.5"
                            width="30"
                            height="46"
                            fill="none"
                        />
                    </g>
                    <line
                        id="Line_14"
                        data-name="Line 14"
                        y2="6"
                        transform="translate(27.5 31.5)"
                        fill="none"
                        stroke={`${view === "internal" ? "#fff" : "#cc2107"}`}
                        strokeWidth="1"
                    />
                    <line
                        id="Line_15"
                        data-name="Line 15"
                        x2="41"
                        transform="translate(16.5 58.5)"
                        fill="none"
                        stroke={`${view === "internal" ? "#fff" : "#cc2107"}`}
                        strokeWidth="1"
                    />
                </svg>
                <span className={`text-[10px] sm:text-[12px] ${view === 'internal' ? 'text-white px-1 sm:px-2' : 'text-gray-700 px-1 sm:px-2'}`}>Internal</span>
            </button>

            {/* Fullscreen toggle */}
            {onToggleFullscreen && (
                <button
                    type="button"
                    onClick={onToggleFullscreen}
                    title={isFullscreen ? "Exit fullscreen" : "View door fullscreen"}
                    className={`transition-colors p-1 sm:p-2 ml-1 ${isFullscreen ? "bg-[#cc2107]/90 text-white" : "bg-white/70 text-gray-700"}`}
                >
                    <FontAwesomeIcon icon={isFullscreen ? faCompress : faExpand} className="w-4 h-4 sm:w-5 sm:h-5" />
                </button>
            )}
        </div>
    );
};

export default DoorView;
